import React, { useState } from 'react';
import SearchForm from './SearchForm';
import { Link } from 'react-router-dom';
import PatientHistory from './PatientHistory';
import OngoingCycles from './OngoingCycles';
import PageHeader from '../../../components/PageHeader';
import ProtectedComponent from '../../../common/ProtectedComponent';
import { permissionsList, permissionsWithAssignedIds } from '../../../api/constant';

const ClinicalManagementLanding = () => {
    const [activeTab, setActiveTab] = useState(1)
    return (
      <ProtectedComponent 
      requiredPermission={permissionsWithAssignedIds[permissionsList.ClinicalManager]}>
            <div className=" container-fluid">
         <div style={{width: '100%'}} className="theme-blush ">
           <PageHeader
          HeaderText="Fertility Management"
          Breadcrumb={[
            {
              name: 'Clinical Management',
              navigate: '/view-fet-patients',
            },
          ]}
        />
      <ul
        className="nav nav-tabs"
        role="tablist"
        style={{
          background: '#ffff',
        }}
      >
        <li
          className={`nav-item mr-1 ${activeTab === 1 ? 'active' : ''}`}
          onClick={() => setActiveTab(1)}
        >
          <Link
            to="#"
            className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
          >
            Search Patient
          </Link>
        </li>
        <li
          className={`nav-item mr-1 ${activeTab === 2 ? 'active' : ''}`}
          onClick={() => setActiveTab(2)}
        >
          <Link
            to="#"
            className={`nav-link ${activeTab === 2 ? 'active' : ''}`}
          >
            Ongoing Cycles
          </Link>
        </li>
      </ul>
      <div className="tab-content component-wrapper">
        {activeTab === 1 && (
          <div className="tab-pane show active">
            <SearchForm />
          </div>
        )}
        {activeTab === 2 && (
          <div className="tab-pane show active">
            <OngoingCycles />
          </div>
        )}
      </div>
    </div>
      </div>
      </ProtectedComponent>
  
   
  );
};

export default ClinicalManagementLanding;
